import { shallowMount, createLocalVue } from '@vue/test-utils';
import Vuex from 'vuex';
import Vuelidate from 'vuelidate';
import AddressEditModal from './AddressEditModal';

const localVue = createLocalVue();
localVue.use(Vuex);
localVue.use(Vuelidate);

describe('AddressEditModal', () => {
  let wrapper;
  let store;

  beforeEach(() => {
    store = new Vuex.Store({
      modules: {
        addressBook: {
          namespaced: true,
          state: {
            editAddressForm: {}
          },
          actions: {},
          mutations: {}
        },

        modal: {
          namespaced: true,
          state: {
            closing: false
          },

          actions: {
            hideModal: jest.fn()
          }
        }
      }
    });

    wrapper = shallowMount(AddressEditModal, {
      store,
      localVue
    });
  });

  test('general snapshot', () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('computed', () => {
    describe('modalTitle', () => {
      test('return title that starts with Edit when editing existing address', () => {
        const localThis = { editAddressForm: { id: 234, street_1: '123 Shotwell St' } };
        expect(AddressEditModal.computed.modalTitle.call(localThis)).toEqual('Edit Address');
      });

      test('return title that starts with Add when adding new address', () => {
        const localThis = { editAddressForm: { street_1: '123 Shotwell St' } };
        expect(AddressEditModal.computed.modalTitle.call(localThis)).toEqual('Add Address');
      });
    });
  });

  describe('methods', () => {
    describe.skip('onSubmit', () => {});
    describe.skip('cancel', () => {});
  });

});
